export function GeneratorFactory(prefix: string): () => string {
  function* newID() {
    let i = 1;
    while (true) {
      yield prefix + i++;
    }
  }

  const generator = newID();
  return () => generator.next().value || prefix;
}
export function timer(span: number): Promise<void> {
  return new Promise((r) => {
    setTimeout(() => {
      r();
    }, span);
  });
}

export function classNames(...names: string[]) {
  return names.filter((c) => c).join(' ');
}
